import styled from "@emotion/styled";
import Colors from "styles/colors";
export const StyledSearchInput = styled.div`
  width: 530px;
  height: fit-content;
  border-radius: 20px;
  border: 1px solid ${Colors.jaco};
  border-right: none;
  display: flex;
  align-items: center;
  position: relative;

  .input {
    border: none;
    outline: none;
    margin-left: 36px;
    padding-right: 4px;
    flex: 1;
	  font-size: 0.875rem
  }

  .search-icon {
    position: absolute;
    left: 10px;
    z-index: 10;
	  
	  svg {
      width: 20px;
	  }
  }

  .button {
    margin-left: auto;
    border-radius: 0;

    .regular-button {
      width: fit-content;
    }
  }
`;
